import moment from "moment";

type Value = [Date, Date];

const pastDate: Date = moment("2000/01/1", "YYYY/MM/DD").toDate();

const getDateRangeFilter = (
  start?: Date,
  end?: Date,
): { value: Value; operator: "between" } => ({
  value: [start || pastDate, end || moment().toDate()],
  operator: "between",
});

export default getDateRangeFilter;
